import clsx from "clsx";
import { Tooltip } from "antd";
import { Badge } from "V2.0/common/badge";
import PortWithLabel from "./PortWithLabel";
import { NodeExecutionStatus } from "./NodeExecutionStatus";

export {
  Node,
  NodeHeader,
  NodeActions,
  NodeBadge,
  NodeName,
  NodeBody,
  NodePorts,
};

function Node({ status, children }) {
  const statusStyles = {
    [NodeExecutionStatus.COMPLETED]: "bg-white border-green-500",
    [NodeExecutionStatus.FAILED]: "bg-white border-red-500",
    [NodeExecutionStatus.RUNNING]: "bg-white border-amber-500",
    [NodeExecutionStatus.SKIPPED]: "bg-white border-pink-500",
    [NodeExecutionStatus.WAITING]: "bg-white border-yellow-500",
    [NodeExecutionStatus.PENDING]: "bg-gray-50 text-gray-500",
    none: "bg-white",
  };

  const styles = [
    "w-[360px] h-[120px]",
    "flex flex-col gap-y-4",
    "border rounded-lg shadow-md",
    "p-4",
  ];

  return <div className={clsx(styles, statusStyles[status])}>{children}</div>;
}

function NodeHeader({ children }) {
  return <div className="flex justify-between items-start">{children}</div>;
}

function NodeBadge(props) {
  const { color, label, icon } = props;

  return (
    <div>
      <Badge color={color}>
        {icon}
        {label}
      </Badge>
    </div>
  );
}

function NodeActions({ hideActions, children }) {
  if (hideActions) return null;

  return <div className="-m-3">{children}</div>;
}

function NodeName(props) {
  const { name } = props;

  return (
    <div>
      <Tooltip title={name}>
        <p className="max-w-[350px] truncate text-xs font-medium">{name}</p>
      </Tooltip>
    </div>
  );
}
function NodeBody({ children }) {
  return <div className="flex flex-col gap-y-2">{children}</div>;
}

function NodePorts(props) {
  const { ports } = props;
  return (
    <>
      {ports.map((port, i) => (
        <PortWithLabel
          key={port}
          port={port}
          index={i}
          total={ports.length}
        />
      ))}
    </>
  );
}
